import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { usePageTitle } from "../contexts/PageTitleContext";
import { certificateService } from "../services/api/certificate.service";
import {
  ApplicationCategory,
  type CertificateApplication,
} from "../types/certificate.types";

const DivorceReprint = () => {
  const { setPageTitle } = usePageTitle();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [applications, setApplications] = useState<CertificateApplication[]>(
    [],
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const isDesktop = window.matchMedia("(min-width: 881px)").matches;
    setSidebarOpen(isDesktop);
    const handleResize = () =>
      setSidebarOpen(window.matchMedia("(min-width: 881px)").matches);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setPageTitle(
      "Divorce — Reprint",
      "Reprint previously issued divorce certificates",
    );
    fetchData();
  }, [setPageTitle]);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError("");
      const data =
        await certificateService.getCertificateApplicationsByCategory(
          ApplicationCategory.Divorce,
        );
      setApplications(Array.isArray(data) ? data : []);
    } catch (err: any) {
      console.error("Error fetching applications:", err);
      setError(err?.message || "Failed to load applications");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`dashboard-body ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
    >
      <Topbar
        onMenuToggle={() => setSidebarOpen((p) => !p)}
        sidebarOpen={sidebarOpen}
      />
      <Sidebar isOpen={sidebarOpen} />
      <main className="main-content">
        <section className="dashboard-hero">
          <div className="dashboard-hero-text">
            <h1>Divorce — Reprint</h1>
            <p>Reprint previously issued divorce certificates.</p>
          </div>
        </section>
        <div
          style={{
            padding: "32px 24px",
            textAlign: "center",
            color: "#8a9ab5",
          }}
        >
          {loading ? <p>Loading applications...</p> : null}
          {error ? <p>{error}</p> : null}
          {!loading && !error ? (
            <p>{applications.length} records loaded.</p>
          ) : null}
          <p style={{ fontSize: "48px" }}>🖨️</p>
          <p style={{ fontSize: "18px", fontWeight: 600 }}>Coming Soon</p>
          <p>The Divorce Reprint module is under development.</p>
        </div>
        <Footer />
      </main>
    </div>
  );
};

export default DivorceReprint;
